module.exports = __webpack_public_path__ + "static/dl2-stay-human_mac-cda1ba918d6f6169f8d9cd5d599683f0.png";